import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import toast from "react-hot-toast";

import Logo from "../components/Logo";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";

const PARENT_URL = "https://getkhojo.com";

export default function RegisterSip() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const register = async () => {
    if (!name.trim() || !email.trim()) { toast.error("Both fields required"); return; }
    setBusy(true);
    try {
      await api.post("/api/auth/register", { name: name.trim(), email: email.trim() });
      toast.success("Account created. Login to continue.");
      setTimeout(() => nav("/login"), 1200);
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : "Registration failed");
    } finally { setBusy(false); }
  };

  const labelStyle = {
    display: "block", fontSize: 12, fontWeight: 600, textTransform: "uppercase",
    letterSpacing: "0.08em", color: "var(--au-text-2)", marginBottom: 8
  };

  return (
    <div className="au-root" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: 20, position: "relative" }}>
      <a className="au-pill au-pill-glass au-pill-sm" href={PARENT_URL} style={{ position: "absolute", top: 24, left: 24, zIndex: 10 }}>
        <ArrowLeft size={16} /> Back
      </a>

      <div className="au-glass au-pad-lg" style={{ maxWidth: 440, width: "100%", position: "relative", zIndex: 5 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: 28 }}>
          <Logo size="large" />
          <div style={{ marginTop: 12, fontSize: 12, fontWeight: 600, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--au-muted)" }}>
            Free · No Credit Card · Instant
          </div>
        </div>

        <h2 style={{ fontSize: 26, fontWeight: 700, margin: 0, marginBottom: 6, textAlign: "center", color: "var(--au-text)" }}>
          Get started
        </h2>
        <p style={{ color: "var(--au-muted)", fontSize: 14, margin: 0, marginBottom: 28, textAlign: "center" }}>
          Create a free SIP Tester account in seconds
        </p>

        <label style={labelStyle}>Full name</label>
        <input
          type="text" value={name} onChange={e => setName(e.target.value)}
          placeholder="Your name" autoFocus
          className="au-input"
          style={{ marginBottom: 18 }}
        />

        <label style={labelStyle}>Email address</label>
        <input
          type="email" value={email} onChange={e => setEmail(e.target.value)}
          onKeyDown={e => e.key === "Enter" && !busy && register()}
          placeholder="you@company.com"
          className="au-input"
          style={{ marginBottom: 24 }}
        />

        <button
          onClick={register} disabled={busy}
          className="au-pill au-pill-primary"
          style={{ width: "100%" }}>
          <Mail size={18} />
          {busy ? "Creating..." : "Create free account"}
          <ArrowRight size={18} />
        </button>

        <div style={{ marginTop: 28, paddingTop: 22, borderTop: "1px solid var(--au-hair)", fontSize: 14, color: "var(--au-muted)", textAlign: "center" }}>
          Already have an account?{" "}
          <Link to="/login" style={{ color: "var(--au-accent-ink)", textDecoration: "none", fontWeight: 600 }}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
